module.exports = __webpack_public_path__ + "img/surprise.b99eef64.svg";